import type { RouteRecordRaw } from 'vue-router'
const entity = "DC_FILE_RECORD"
const routers: RouteRecordRaw = {
  path: '/file-record',
  name:'file-record',
  meta: {
    title: '附件列表'
  },
  children: [
    {
      path: 'list',
      name: 'file-record-list',
      meta: {
        title: '附件列表'
      },
      props:{
        entity:entity,
      },
      component: ()=>{return import("../../views/dynamic-form/DynamicListView.vue")}
    }
  ]
}
export default routers
